import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Zombie death",
  "description": "",
  "published": "2007-01-08T00:00:00.000Z",
  "redirect_from": ["/blog/zombie-death/swizec/331"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The internet has been overrun by a zombie infestation and it is our job to rid the world of this pest. If you wish to aid in our cause eat the blue pill and go `}<a parentName="p" {...{
        "href": "http://www.crazymonkeygames.com/PlayBoxheadRooms.php"
      }}>{`here`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      